import type {
  CDArea,
  CDFirestop,
  CDProject,
  CDRoom,
} from 'components/construction-documentation-fi/construction-documentation-types';
import { useConstructionDocumentation } from 'composables/constructionDocumentation';
import { useDict } from 'composables/fischerPlugin';
import { defineStore } from 'pinia';

export const useConstructionDocumentationStore = defineStore('construction-documentation', {
  state() {
    return {
      pageType: null as string | null,
      projectId: null as string | null,
      project: null as CDProject | null,
      areaId: null as string | null,
      area: null as CDArea | null,
      roomId: null as string | null,
      room: null as CDRoom | null,
      firestopId: null as string | null,
      firestop: null as CDFirestop | null,
      isArchive: false as boolean,
      isLoading: false as boolean,
      dict: useDict(),
    };
  },
  actions: {
    async setPageType(pageType: string) {
      const { loadConstructionDocumentationData, setBrowserPageTitle } =
        useConstructionDocumentation();
      this.isArchive = pageType === 'archive';
      this.pageType = pageType;

      if (this.projectId) {
        await loadConstructionDocumentationData();
      }

      let browserTitle =
        this.firestop?.name || this.room?.name || this.area?.name || this.project?.name;

      if (pageType === 'audit-log') {
        browserTitle = this.dict.get('construction-Projects.Breadcrumb.Audit-Log') || 'Audit Log';
      }

      if (pageType === 'archive') {
        browserTitle = this.dict.get('construction-Projects.Breadcrumb.Archive') || 'Archive';
      }

      setBrowserPageTitle(browserTitle);
    },
  },
  getters: {
    isOverviewPage(state) {
      return state.pageType === 'overview';
    },
    isOverviewPageArchive(state) {
      return state.pageType === 'archive';
    },
    isProjectPage(state) {
      return state.pageType === 'project';
    },
    isProjectAreaPage(state) {
      return state.pageType === 'area';
    },
    isProjectRoomPage(state) {
      return state.pageType === 'room';
    },
    isFirestopPage(state) {
      return state.pageType === 'firestop';
    },
    isArchivePage(state) {
      return state.pageType === 'archive';
    },
    isAuditLogPage(state) {
      return state.pageType === 'audit-log';
    },
  },
});
